import { render, staticRenderFns } from "./NewAppointment.vue?vue&type=template&id=32b27766&scoped=true&"
import script from "./NewAppointment.vue?vue&type=script&lang=js&"
export * from "./NewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./NewAppointment.vue?vue&type=style&index=0&id=32b27766&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b27766",
  null
  
)

export default component.exports